//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: in order to be accessible this toggle should hide checkbox under it
export default {
  props: {
    okLabel: {
      type: String,
      default: '',
    },
    noLabel: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    toggle() {
      // this.value = !this.value;
      this.$emit('input', !this.value);
    },
  },
};
